"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _dates = require("../_utils/dates");
var _Truncate = _interopRequireDefault(require("../Truncate"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    heading: {
      display: 'block',
      fontSize: '18px',
      lineHeight: '1.2em',
      fontWeight: 900,
      margin: '24px 0 16px !important'
    },
    ctaLink: {
      color: 'inherit',
      fontWeight: 900,
      lineHeight: 1.53,
      fontSize: theme.typography.pxToRem(14),
      textTransform: 'capitalize'
    },
    list: {
      width: '100%',
      '& a': {
        fontWeight: "".concat(theme.typography.fontWeightBold, " !important")
      }
    },
    icon: {
      fontSize: theme.typography.pxToRem(18),
      verticalAlign: 'middle'
    },
    date: {
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: 1.53
    }
  };
});
var displayDate = function displayDate(startDate) {
  if (startDate) {
    return (0, _dates.formatDateTo)(startDate, 'dd MMM yyy');
  } else {
    return '';
  }
};
var Item = function Item(props) {
  var _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    url = props.url;
  var classes = useStyles();
  var startDate = props['start-date'];
  return __jsx(_react.default.Fragment, null, __jsx(_Truncate.default, {
    divTag: true,
    lines: 3
  }, startDate && __jsx("span", {
    className: classes.date
  }, displayDate(startDate), " - "), __jsx(_core.Link, {
    target: "_parent",
    href: url,
    dangerouslySetInnerHTML: {
      __html: title
    }
  })));
};
var LatestCollections = function LatestCollections(props) {
  var items = props.items,
    heading = props.heading,
    totalEventsDisplay = props.totalEventsDisplay,
    ctaTitle = props.ctaTitle,
    ctaLink = props.ctaLink,
    openNewTab = props.openNewTab,
    className = props.className,
    anchorId = props.anchorId;
  var theme = (0, _styles.useTheme)();
  var classes = useStyles();
  var titleStyle = {
    borderBottom: props.bottomBorder ? "1px solid ".concat(theme.palette.grey[400]) : 'none !important'
  };
  return __jsx("div", {
    id: anchorId,
    className: "aem-ms-cmp aem-ms-grid-view ".concat(className)
  }, heading && __jsx("p", {
    className: classes.heading,
    style: titleStyle,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), __jsx("ul", null, items && items.map(function (item, index) {
    return __jsx(_react.default.Fragment, null, index < totalEventsDisplay ? __jsx("li", {
      className: classes.list,
      key: index
    }, __jsx(Item, item), ' ') : false);
  }), ctaTitle && ctaLink && items && __jsx("li", {
    className: classes.list
  }, __jsx(_core.Link, {
    target: openNewTab ? '_blank' : '_self',
    href: ctaLink
  }, __jsx(_core.Typography, {
    className: classes.ctaLink,
    component: "span",
    dangerouslySetInnerHTML: {
      __html: ctaTitle
    }
  }), __jsx(_ChevronRight.default, {
    className: classes.icon
  })))));
};
var _default = LatestCollections;
exports.default = _default;